import axios from 'axios';
import client from './apiClient';
import {
  DeactivateLinearCustomerMappingRequest,
  LinearCustomerMapping,
  LinearCustomerSummary,
  SetLinearCustomerMappingRequest,
} from '../models/linearCustomerMapping';

const rootPath = '/super-admin/linear-customer-mappings';
const basePath = (tenantId: string) => `${rootPath}/${tenantId}`;

// Linear Customers that are not yet connected to any tenant, for the connect picker.
export const getUnassignedLinearCustomers = async (): Promise<LinearCustomerSummary[]> => {
  const { data } = await client.get<LinearCustomerSummary[]>(`${rootPath}/unassigned-customers`);
  return data;
};

// Returns null when the tenant has no mapping row yet (backend responds 404).
export const getLinearCustomerMapping = async (
  tenantId: string
): Promise<LinearCustomerMapping | null> => {
  try {
    const { data } = await client.get<LinearCustomerMapping>(basePath(tenantId));
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const deactivateLinearCustomerMapping = async (
  tenantId: string,
  request: DeactivateLinearCustomerMappingRequest
): Promise<void> => {
  await client.post(`${basePath(tenantId)}/deactivate`, request);
};

export const reactivateLinearCustomerMapping = async (tenantId: string): Promise<void> => {
  await client.post(`${basePath(tenantId)}/reactivate`);
};

export const setLinearCustomerMapping = async (
  tenantId: string,
  request: SetLinearCustomerMappingRequest
): Promise<void> => {
  await client.post(`${basePath(tenantId)}/set-customer`, request);
};
